import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import CurrencyRatioPageContainer from './CurrencyRatioPageContainer';
import { actions } from './CurrencyRatioPageContainer.actions';
import {
    getSelectOptions,
    getCurrenciesList
} from './CurrencyRatioPageContainer.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    selectOptions: getSelectOptions,
    currenciesList: getCurrenciesList
});

const CurrencyRatioPageContainerComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            location: state.routing.locationBeforeTransitions,
            loading: state.currencyRatios.loading,
            totalPages: state.currencyRatios.total,
            currency: state.user?.publisher?.account?.balance?.currency || 'USD',
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getCurrencyRatios: actions.getCurrencyRatios,
            onChangeData: actions.onChangeData,
            getCurrenciesList: actions.getCurrenciesList
        };
    }
)(CurrencyRatioPageContainer);

export default CurrencyRatioPageContainerComponent;
